import React from 'react';
import FormControlLabel from '@mui/material/FormControlLabel';
import Checkbox from '@mui/material/Checkbox';

export default props => {
  const { label, classes = {}, ...rest } = props;
  const input = props.input || {
    checked: props.checked ?? !!props.value,
    onChange: props.onChange,
    value: props.value
  };

  return (
    <FormControlLabel
      className={classes.checkboxGroupItem}
      control={
        <Checkbox
          checked={Boolean(input.checked ?? input.value)}
          onChange={input.onChange}
          {...rest}
        />
      }
      label={label}
    />
  );
};
